import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Briefcase } from "lucide-react";
import { getOccupationGroupContent } from "@/lib/occupationContent";

interface WhatDoTheyDoProps {
  occupationTitle: string;
  description?: string;
  socCode?: string;
}

/**
 * "What Do [Occupation] Do?" section
 * Provides occupation description and responsibilities
 */
export default function WhatDoTheyDo({ 
  occupationTitle, 
  description,
  socCode 
}: WhatDoTheyDoProps) {
  // Fall back to occupation-family-specific context (keyed off SOC major
  // group) rather than one-size-fits-all boilerplate
  const group = getOccupationGroupContent(socCode);
  const defaultDescription =
    `${occupationTitle} positions belong to the ${group.groupName.toLowerCase()} field. ${group.workContext}`;

  const content = description || defaultDescription;

  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Briefcase className="h-5 w-5" />
          What Do {occupationTitle} Do?
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground leading-relaxed mb-4">
          {content}
        </p>
        {socCode && (
          <p className="text-sm text-muted-foreground">
            <strong>Standard Occupational Classification (SOC) Code:</strong> {socCode}
          </p>
        )}
      </CardContent>
    </Card>
  );
}

